"use client";
import {
  TooltipArrow,
  TooltipContent,
  Tooltip as TooltipPrimitive,
  TooltipProvider,
  TooltipTrigger,
} from "@radix-ui/react-tooltip";
import * as React from "react";

export default function Tooltip({
  children,
  content,
  side = "top",
  className,
}: {
  children: React.ReactNode;
  content: string;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
}) {
  return (
    <TooltipProvider>
      <TooltipPrimitive>
        <TooltipTrigger asChild className={className}>
          {children}
        </TooltipTrigger>
        <TooltipContent
          side={side}
          sideOffset={4}
          className="bg-brand-secondary-dark relative z-[9999] m-3 max-w-[400px] rounded-md px-4 py-2 text-base text-white opacity-75"
        >
          {content}
          <TooltipArrow className="fill-brand-secondary-dark" />
        </TooltipContent>
      </TooltipPrimitive>
    </TooltipProvider>
  );
}
